(function (ws) {
    'use strict';
    ws.views.quoteQuickEntryList = Backbone.View.extend({

        events: {
            'submit .qqe-add-to-cart': 'addToCart'
        },

        /**
         * Initialize
         */
        initialize: function () {
            this.$errors = this.$('.qqe-cart-errors, .qqe-cart-error-products');
            this.$productInput = this.$('textarea[name="productCodePost"]');
            this.openCartModalId = this.$('.qqe-open-modal').attr('data-modalCart');
            this.itemContainer = this.$('.comp-addtocart-cont');
            this.$invalidProdError = this.$('.qqe-cart-invalid-error');
            this.$zeroPriceError = this.$('.qqe-cart-zeroprice-error');
            this.confirmModalId = this.$('.crt-clear-confirm').attr('id');
            $('.yes').on('click', this.clearCart.bind(this));

            //for spinner
            this.$saveButton = this.$('.qqe-open-modal');

            //global errors
            this.$globalErrors = $('#globalMessages');
            this.$apiError = this.$('.api-error-message');

            //Invalid and Zero price errors
            this.$inlineInvalidZeroPriceErrors = this.$('.qqe-invalid-zeroprice-errors');

            //Restricted Product Error
            this.$restrictedProdError = this.$('.qqe-restrictedProdError');
            this.$restrictedProdCode = this.$('.qqe-restrictedProduct-code');
            this.$restrictedNumberList = this.$('.numList');

            //Obsolete Product Error
            this.$obsoleteError = this.$('.qqe-cart-obsolete-error');
            this.$nonObsoleteError = this.$('.qqe-cart-non-obsolete-error');
            this.$zcsqqeerrorProducts = this.$('.qqe-cart-zcs-error-products');
        },

        /**
         *
         */
        clearCart: function (e) {
            this.eventAgg.trigger(this.confirmModalId + 'close');
            this.addToCart(e, true);
        },

        /**
         * Launch Cart Modal
         * @param {Object} e
         */
        openCartModal: function (e) {
            e.preventDefault();
            this.eventAgg.trigger(this.openCartModalId);
            if (this.collection.models.length > 0) {
                this.eventAgg.trigger(this.openCartModalId);
            }
        },

        /**
         * Add to Cart
         * @param {Object} e
         */
        addToCart: function (e, proceed) {
            e.preventDefault();
            var query = $('.queryInput').val();
            this.$apiError.hide();
            if ($.trim(query).length === 0) {
                $('#queryErrMsg').show();
                $('.qqe-cart-errors').hide();
                e.preventDefault();
            } else {

                //enable Spinner
                this.$saveButton.addClass('spinner-before no-padding').prop('disabled', true);
                this.$productInput.prop('disabled', true);

                //Then, use request object to create a new model and call BE api,
                //so some of the below code will need to be modified

                $('.qqe-cart-errors, #queryErrMsg').hide();
                var products = this.$productInput.val().trim();
                var _this = this;
                var productsArray = new ws.models.quoteQuickEntry();
                this.$errors.hide();
                productsArray.set({productCode: products, proceed: proceed ? true : false});
                productsArray.save().done(function (data) {
                    $('.qqe-cart-allInvalidVendorProducts-error').addClass('hide');
                    if (data.allInvalidVendorProducts) {
                        $('.qqe-cart-allInvalidVendorProducts-error').removeClass('hide');
                    }

                    if (data.is3PLOrder) {
                        //disable spinner
                        this.$saveButton.removeClass('spinner-before no-padding').prop('disabled', false);
                        this.$productInput.prop('disabled', false);
                        this.eventAgg.trigger(this.confirmModalId);
                    } else {
                        var cartItem = new ws.views.cartItemList({model: data});
                        $('.comp-invalid-cont').find('.comp-invalid-cont-products').html();
                        $('.comp-invalid-cont').addClass('hide');
                        if (data.disabledVendorSalesOrgProduct && data.disabledVendorSalesOrgProduct.length) {
                            $('.comp-invalid-cont').find('.comp-invalid-cont-products').html(data.disabledVendorSalesOrgProduct);
                            $('.comp-invalid-cont').find('.error-message').css('display', 'block');
                            $('.comp-invalid-cont').removeClass('hide');
                        }

                        this.$inlineInvalidZeroPriceErrors.show();

                        if (data.msProductMessage && data.data) {
                            this.eventAgg.trigger(_this.openCartModalId);
                            this.itemContainer.html(cartItem.render().el);
                            this.$inlineInvalidZeroPriceErrors.hide();
                            this.$errors.hide();
                            this.$productInput.val('');
                        } else if (data.msProductMessage) {
                            this.showqqeZcsErrors(data.msProductMessage);
                        }

                        if (data.error && !data.data) {
                            this.showErrors(data.error);
                            this.itemContainer.empty();
                        } else if (data.error && data.data) {
                            this.itemContainer.html(cartItem.render().el);
                            this.showErrors(data.error);
                        } else if (!data.error && data.data) {
                            this.eventAgg.trigger(_this.openCartModalId);
                            this.itemContainer.html(cartItem.render().el);
                            this.$inlineInvalidZeroPriceErrors.hide();
                            this.$errors.hide();
                            this.$productInput.val('');
                        }

                        if (data.data) {
                            dataLayerAA.cart = {};
                            dataLayerAA.cart.category = 'cart';
                            dataLayerAA.cart.type = 'add';
                            dataLayerAA.cart.action = 'quick entry';
                            dataLayerAA.product = [];

                            _.each(data.data, function (item) {
                                let product = {};
                                product.name = item.product.name;
                                product.id = (!_.isNull(item.product.manufacturerPart)) ? item.product.manufacturerPart : item.product.code;
                                product.quantity = item.totaItems;
                                product.price = item.customerPrice;
                                product.vendor = (!_.isNull(item.product.brandName)) ? item.product.brandName : item.product.vendorName;
                                product.category = (!_.isNull(item.product.derivedCategories)) ? item.product.derivedCategories : '';

                                dataLayerAA.product.push(product);
                            });

                            _satellite.track('event:cart');
                        }

                        //disable spinner
                        this.$saveButton.removeClass('spinner-before no-padding').prop('disabled', false);
                        this.$productInput.prop('disabled', false);
                        this.showRemoteErrors(data);

                        this.eventAgg.trigger('updateCart');
                    }
                }.bind(this)).fail(function() {
                    this.$apiError.show();
                    this.$saveButton.removeClass('spinner-before no-padding').prop('disabled', false);
                    this.$productInput.prop('disabled', false);
                }.bind(this));
            }
        },

        /**
         * Show Error messages
         * @param {Object} errors
         */
        showErrors: function (errors) {
            this.$('.qqe-cart-error-products').html(errors);
            this.$('#queryErrMsg').hide();
            this.$errors.show();
        },

        showqqeZcsErrors: function (errors) {
            this.$zcsqqeerrorProducts.html(errors);
            this.$zcsqqeerrorProducts.show();
        },

        /**
         *
         * @param {*} response
         */
        showRemoteErrors: function (response) {
            this.$zeroPriceError.find('.qqe-zeroprice-products').html(response.zeroListPriceProduct);
            this.$invalidProdError.find('.qqe-invalid-products').html(response.inValidProducts);

            this.$globalErrors.hide();
            this.$zeroPriceError.hide();
            this.$invalidProdError.hide();
            this.$restrictedProdError.hide();
            this.$obsoleteError.hide();
            this.$zcsqqeerrorProducts.hide();

            if (response.inValidProducts && !response.zeroListPriceProduct) {
                this.$invalidProdError.show();
            } else if (response.zeroListPriceProduct && !response.inValidProducts) {
                this.$zeroPriceError.show();
            } else if (response.inValidProducts && response.zeroListPriceProduct) {
                this.$zeroPriceError.show();
                this.$invalidProdError.show();
            }

            if (response.msProductMessage) {
                this.showqqeZcsErrors(response.msProductMessage);
            }

            if (response.restrictedProduct) {
                this.$restrictedProdCode.html(response.restrictedProduct);
                this.$restrictedNumberList.html(response.baseStorePhNumberList.join(', '));
                this.$restrictedProdError.show();
            }

            if (response.obsoleteProducts) {
                let errorString = '<ul style="color: #d81010;">';
                _.each(response.obsoleteProducts, function (error) {
                    errorString += '<li>' + error + '</li>';
                });
                errorString += '</ul>';
                this.$obsoleteError.html(errorString).show();
            }

            if (response.nonObsoleteWanings) {
                let errorString = '<ul style="color:#9f6000 !important;">';
                _.each(response.nonObsoleteWanings, function (error) {
                    errorString += '<li>' + error + '</li>';
                });
                errorString += '</ul>';
                this.$nonObsoleteError.html(errorString).show();
            }

        }
    });

    ws.views.cartItemList = Backbone.View.extend({
        tagName: 'div',

        /**
         * Initialize
         */
        initialize: function () {
            this.template = _.template($('#qqe-cart-list').html());
        },

        /**
         * Render
         */
        render: function () {
            this.$el.html(this.template(this.model));
            return this;
        }
    });
})(westcon);
